import React, { useState } from 'react'
import { Container, Card, Row, Col, Form, Button } from 'react-bootstrap'
import ClockTimePicker from '../../../../GlobalModules/Utility/Components/ClockTimePicker'
import TimePicker12 from '../../../../GlobalModules/Utility/Components/TimePicker12'
import { useHistory, useParams } from 'react-router-dom'
import { connect } from 'react-redux'
import * as BookingEventsController from '../Controller/BookingEventsController'
import Utility from '../../../../GlobalModules/Utility/Utility'

const EVENT_TYPES = [
  { value: 'BOOKING', label: 'Booking' },
  { value: 'EVENT', label: 'Event' },
  { value: 'PARTY', label: 'Party' },
  { value: 'MEETING', label: 'Meeting' }
]

const AddBooking = (props) => {
  const history = useHistory()
  const { lng } = useParams()
  const [saving, setSaving] = useState(false)
  const [form, setForm] = useState({
    event_type: 'BOOKING',
    start_date: '',
    start_time: '',
    start_time_24: '',
    start_h: '12',
    start_m: '00',
    start_ap: 'AM',
    end_date: '',
    end_time: '',
    end_time_24: '',
    end_h: '12',
    end_m: '00',
    end_ap: 'AM',
    name: '',
    email: '',
    phone: '',
    no_of_persons: '',
    description: ''
  })
  const [errors, setErrors] = useState({})

  const clearError = (field) => {
    setErrors((prev) => {
      const newErrors = { ...prev }
      delete newErrors[field]
      return newErrors
    })
  }

  const onChange = (e) => {
    const { name, value } = e.target
    clearError(name)
    setForm((p) => ({ ...p, [name]: value }))
  }

  const pad2 = (n) => String(n).padStart(2, '0')
  const now = new Date()
  const todayStr = now.toISOString().split('T')[0]
  const nowHHMM = `${pad2(now.getHours())}:${pad2(now.getMinutes())}`
  const isSameDate = (a, b) => a && b && a === b
  const toDateTime = (d, t) => (d && t ? new Date(`${d}T${t}`) : null)

  const validate = () => {
    const e = {}
    if (!form.start_date) e.start_date = 'Please enter booking/event start date'
    if (!form.start_time && !form.start_time_24)
      e.start_time = 'Please enter booking/event start time'
    if (!form.end_date) e.end_date = 'Please enter booking/event end date'
    if (!form.end_time && !form.end_time_24)
      e.end_time = 'Please enter booking/event end time'
    // Removed validation for name, email, phone, no_of_persons as requested

    const startDT = toDateTime(form.start_date, form.start_time_24)
    const endDT = toDateTime(form.end_date, form.end_time_24)
    // Only rule: if same day, end cannot be earlier than start (equal allowed)
    if (
      startDT &&
      endDT &&
      form.start_date &&
      form.end_date &&
      form.start_date === form.end_date &&
      endDT < startDT
    )
      e.end_time = 'End must be after or equal to start'
    setErrors(e)
    return Object.keys(e).length === 0
  }

  const onSubmit = async () => {
    if (!validate()) return
    try {
      setSaving(true)
      const {
        start_time_24,
        end_time_24,
        start_h,
        start_m,
        start_ap,
        end_h,
        end_m,
        end_ap,
        ...payload
      } = form
      if (!payload.start_time && start_time_24)
        payload.start_time = to12Hour(start_time_24)
      if (!payload.end_time && end_time_24)
        payload.end_time = to12Hour(end_time_24)
      // Fix: Send "0" if no_of_persons is blank
      if (!payload.no_of_persons || payload.no_of_persons === '') {
        payload.no_of_persons = '0'
      }

      // Add store_id to payload
      let storeId = null
      if (props.userEntryType?.user_type === 'staff') {
        if (localStorage.getItem('store_id') == null) {
          localStorage.setItem('store_id', props.userEntryType.branch_id)
        }
        storeId = localStorage.getItem('store_id')
      } else {
        // For admin users, get store_id from user credentials or use default
        storeId =
          props.userCredentials?.store_id || localStorage.getItem('store_id')
      }
      payload.store_id = storeId

      const res = await BookingEventsController.createBookingApi(payload)
      if (res?.success) {
        Utility.toastNotifications(
          'Booking created successfully',
          'Success',
          'success'
        )
        history.push(`/${lng}/booking-events`)
      } else {
        Utility.toastNotifications(
          res?.message || 'Failed to create booking',
          'Error',
          'error'
        )
      }
    } finally {
      setSaving(false)
    }
  }

  const onSubmitSafe = async () => {
    try {
      await onSubmit()
    } catch (err) {
      const msg =
        err?.response?.data?.message || err?.message || 'Failed to save'
      Utility.toastNotifications(msg, 'Error', 'error')
    }
  }

  const err = (key) => errors[key]

  const to12Hour = (hhmm) => {
    if (!hhmm) return ''
    const [hStr, mStr] = hhmm.split(':')
    let h = parseInt(hStr || '0', 10)
    const m = parseInt(mStr || '0', 10)
    const ampm = h >= 12 ? 'PM' : 'AM'
    h = h % 12
    if (h === 0) h = 12
    return `${h}:${m < 10 ? '0' : ''}${m} ${ampm}`
  }

  const to24FromParts = (hStr, mStr, ap) => {
    let h = parseInt(hStr || '12', 10)
    const m = parseInt(mStr || '0', 10)
    const isPM = String(ap || 'AM').toUpperCase() === 'PM'
    if (isPM && h < 12) h += 12
    if (!isPM && h === 12) h = 0
    return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`
  }

  return (
    <Container fluid className='p-0'>
      <div className='d-flex justify-content-between align-items-center top-header-box'>
        <h4>Add Booking or Event</h4>
        <Button onClick={onSubmitSafe} disabled={saving}>
          {saving ? 'Saving...' : 'Save'}
        </Button>
      </div>
      <Card>
        <Card.Body>
          <Row className='g-3'>
            <Col md={4}>
              <Form.Label>Event Type</Form.Label>
              <Form.Select
                name='event_type'
                value={form.event_type}
                onChange={onChange}
              >
                {EVENT_TYPES.map((t) => (
                  <option key={t.value} value={t.value}>
                    {t.label}
                  </option>
                ))}
              </Form.Select>
            </Col>
          </Row>

          <Row className='g-3 mt-1'>
            <Col md={4}>
              <Form.Label>Booking or Event Start Date</Form.Label>
              <Form.Control
                type='date'
                name='start_date'
                value={form.start_date}
                onChange={onChange}
                isInvalid={!!err('start_date')}
                placeholder='Please enter booking/event start date'
                min={todayStr}
              />
              {err('start_date') && (
                <div className='invalid-feedback d-block'>
                  Start Date is required
                </div>
              )}
            </Col>
            <Col md={4}>
              <Form.Label>Booking or Event Start Time</Form.Label>
              <ClockTimePicker
                value24={form.start_time_24}
                onChange={(val24) => {
                  setForm((p) => ({
                    ...p,
                    start_time_24: val24,
                    start_time: to12Hour(val24)
                  }))
                  setErrors((prev) => {
                    const copy = { ...prev }
                    delete copy.start_time
                    return copy
                  })
                }}
                placeholder='Please enter booking/event start time'
              />
              {!form.start_time && !form.start_time_24 && err('start_time') && (
                <div className='invalid-feedback d-block'>
                  Start Time is required
                </div>
              )}
            </Col>
          </Row>

          <Row className='g-3 mt-1'>
            <Col md={4}>
              <Form.Label>Booking or Event End Date</Form.Label>
              <Form.Control
                type='date'
                name='end_date'
                value={form.end_date}
                onChange={onChange}
                isInvalid={!!err('end_date')}
                placeholder='Please enter booking/event end date'
                min={form.start_date || todayStr}
              />
              {err('end_date') && (
                <div className='invalid-feedback d-block'>
                  End Date is required
                </div>
              )}
            </Col>
            <Col md={4}>
              <Form.Label>Booking or Event End Time</Form.Label>
              <ClockTimePicker
                value24={form.end_time_24}
                min24={(function() {
                  if (
                    isSameDate(form.end_date, form.start_date) &&
                    form.start_time_24
                  ) {
                    // Same day: end time cannot be earlier than start time (equal allowed)
                    return form.start_time_24
                  }
                  return undefined
                })()}
                onChange={(val24) => {
                  setForm((p) => ({
                    ...p,
                    end_time_24: val24,
                    end_time: to12Hour(val24)
                  }))
                  setErrors((prev) => {
                    const copy = { ...prev }
                    delete copy.end_time
                    return copy
                  })
                }}
                placeholder='Please enter booking/event end time'
              />
              {!form.end_time && !form.end_time_24 && err('end_time') && (
                <div className='invalid-feedback d-block'>
                  End Time is required
                </div>
              )}
            </Col>
          </Row>

          <Row className='g-3 mt-1'>
            <Col md={4}>
              <Form.Label>Name</Form.Label>
              <Form.Control
                name='name'
                value={form.name}
                onChange={onChange}
                placeholder='Please enter name'
              />
            </Col>
            <Col md={4}>
              <Form.Label>Email</Form.Label>
              <Form.Control
                name='email'
                value={form.email}
                onChange={onChange}
                placeholder='Please enter email'
              />
            </Col>
            <Col md={4}>
              <Form.Label>Contact No</Form.Label>
              <Form.Control
                name='phone'
                value={form.phone}
                // onChange={onChange}
                onChange={(e) => {
                  Utility.handlePhoneInput(e);
                  onChange(e);
                }}
                minLength="10"
                maxLength="15"
                placeholder='Please enter phone'
              />
            </Col>
          </Row>

          <Row className='g-3 mt-1'>
            <Col md={4}>
              <Form.Label>No of Persons</Form.Label>
              <Form.Control
                name='no_of_persons'
                value={form.no_of_persons}
                // onChange={onChange}
                placeholder='Please enter no of persons'
                onChange={(e) => {
                  Utility.handlePhoneInput(e);
                  onChange(e);
                }}
              />
            </Col>
          </Row>

          <Row className='g-3 mt-1'>
            <Col md={8}>
              <Form.Label>Description</Form.Label>
              <Form.Control
                as='textarea'
                rows={5}
                name='description'
                value={form.description}
                onChange={onChange}
                placeholder='Enter description'
              />
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Container>
  )
}

const mapStateToProps = (globalState) => ({
  userCredentials: globalState.LoginReducer.userCredentials,
  userEntryType: globalState.LoginReducer.userEntryType
})

export default connect(mapStateToProps)(AddBooking)
